import { WidgetType } from 'domain/entity/widget';

export type WidgetImage = {
    description: WidgetImageDescription;
    type: WidgetType;
    url: string;
};

export class WidgetImageDescription {
    constructor(readonly title: string) {}
}

class ImageData implements WidgetImage {
    type = WidgetType.IMAGE;

    constructor(readonly url: string, readonly description: WidgetImageDescription) {}
}

export default ImageData;
